import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteAsset = ({
    selectedData,
    setIsDeleteAsset,
    deleteAssetLoading,
    deleteAssetMutate,
}) => {
    const handleDeactivateSubmit = () => {
        deleteAssetMutate({ id: selectedData?.id });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteAsset}
            title={
                "Asset Delete"
            }
        >
            <WarningText>
                Are you sure you want to delete this asset.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteAsset(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeactivateSubmit}
                    disabled={deleteAssetLoading}
                    className={`border 
                           border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white
                        }`}
                >
                    {deleteAssetLoading ? "Deleting..." : "Confirm"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteAsset;
